import { render } from "./StagesView.vue?vue&type=template&id=9e225082&scoped=true"
import script from "./StagesView.vue?vue&type=script&lang=js"
export * from "./StagesView.vue?vue&type=script&lang=js"

import "./StagesView.vue?vue&type=style&index=0&id=9e225082&scoped=true&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e225082"]])

export default __exports__